module.exports = __webpack_public_path__ + "static/media/bea93e59-b845-4ad5-b49f-329c30f1dbce.fd24e436.jpg";